import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Layout from "@/components/layout/Layout";
import { CrumbBar } from "@/components/layout/Crumbs";
import api from "@/lib/api";
import { themeOf } from "@/lib/mall";
import { useMall } from "@/context/MallContext";
import { DirectoryStrip } from "@/components/directory/DirectoryStrip";
import { ShopHome } from "@/components/mall/ShopHome";

/** /stores/:slug — the shop's home page. The directory strip (list + map) sits at the bottom, above the footer. */
export default function StorePage() {
    const { slug } = useParams();
    const navigate = useNavigate();
    const { enter, leave } = useMall();
    const [site, setSite] = useState(null);
    const [err, setErr] = useState(false);

    useEffect(() => {
        setSite(null);
        setErr(false);
        api.get(`/stores/site/${slug}`).then(({ data }) => {
            setSite(data);
            enter({ ...data.store, designers: data.store.designers ?? data.store.designers_enabled }, "store");
        }).catch(() => setErr(true));
    }, [slug, enter]);

    if (err) return (
        <Layout><div className="mx-auto max-w-3xl px-4 py-24 text-center">
            <p className="text-zinc-600" data-testid="store-missing">That shop is not in the directory.</p>
            <Link to="/directory" className="mt-4 inline-block font-semibold text-zinc-900 underline">Browse every shop</Link>
        </div></Layout>
    );
    if (!site) return <Layout><div className="flex justify-center py-32"><Loader2 className="animate-spin text-zinc-400" /></div></Layout>;

    return (
        <Layout>
            <CrumbBar trail={[{ label: "Shops", to: "/directory" }, { label: site.store.name }]} />
            <ShopHome site={site} directory onBack={() => { leave(); navigate("/directory"); }} />
            <DirectoryStrip store={site.store} theme={themeOf(site.store)} />
        </Layout>
    );
}
